import AdminAPIClient from '@/domain/repository/admin_api_client';
import { InjectionKey } from 'vue';

export const AdminAPIClientKey: InjectionKey<AdminAPIClient> = Symbol('AdminAPIClient');

